var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrowBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.9vw",
    height: "1.9vw",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7744 15.4932L21.0625 19.9404L21.2227 20.0752L21.0625 20.2109L15.9541 24.5059L17.4561 25.7695L24.2266 20.0752L17.2764 14.2295L15.7744 15.4932Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.353205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrowBox);
export default __webpack_public_path__ + "static/media/NextArrowBox.6772dee95c6d3ca7cf9e883614783b67.svg";
export { ForwardRef as ReactComponent };